import { compose, pure, withHandlers, withState } from "recompose";

import Queries from "../../queries/queries2";
import React from "react";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import _ from "lodash";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

const data = graphql(Queries.getPeriodSelecterDataForSales, {
  // name: "getPeriodSelecterDataForSales",
  // variables: {
  //   companyId: this.props
  // },
  options: {
    fetchPolicy: "cache-and-network"
  }
  // props: ({ getBudgetItems, getBudgetItems: { refetch } }) => {
  //   return {
  //     refetch,
  //     getBudgetItems
  //   };
  // }
});

class BudgetSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      type: props.type,
      value: { label: "..." }
    };
  }

  // update value after props update
  static getDerivedStateFromProps(props, state) {
    if (
      props &&
      state.real &&
      state.budgetBackups &&
      (props.id !== state.id ||
        props.year !== state.year ||
        props.date !== state.date ||
        props.type !== state.type)
    ) {
      let value = state.options[0];

      if (props.type === "ROLLING_BUDGET") {
        value = state.options[0];
      }
      if (props.type === "BUDGET_BACKUP") {
        value = _.filter(state.budgetBackups, { id: props.id })[0];
      }
      if (props.type === "REAL") {
        if (!!!props.year) {
          // no year specified
          value = {...state.real[0]};
        } else {
          value = {..._.filter(state.real, { year: props.year })[0]};
        }

        if (props.customDate) {
          value.id = null;
          value.year = null;
          value.label = props.intl.formatMessage({ id: "ids_real" });
        }
      }
      return { value };
    }
    return null;
  }

  // update options and value after data update
  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data && !this.props.data.loading) {
      console.log("data", this.props.data);
      const data = this.props.data.getPeriodSelecterDataForSales;
      let options = [];

      // ROLLING BUDGET
      const rolling = _.filter(data, { type: "ROLLING_BUDGET" });
      options.push({
        label: this.props.intl.formatMessage({ id: "ids_rollingBudget" }),
        id: rolling[0].id,
        type: "ROLLING_BUDGET"
      });

      // REAL
      const realTranslation = this.props.intl.formatMessage({ id: "ids_real" });
      let real = _.filter(data, { type: "REAL" });
      real = _.sortBy(real, ["year"]);
      real = real.reverse().map(o => {
        return {
          label: `${realTranslation} ${o.year}`,
          id: o.id,
          year: o.year,
          type: "REAL"
        };
      });
      if (real) options.push(...real);

      // BUDGET BACKUP
      let budgetBackups = _.filter(data, { type: "BUDGET_BACKUP" });
      budgetBackups = _.sortBy(budgetBackups, ["year"]);
      budgetBackups = budgetBackups.map(o => {
        return {
          label: o.budgetBackupName,
          id: o.id,
          date: o.budgetBackupDate,
          type: "BUDGET_BACKUP"
        };
      });
      if (budgetBackups) options.push(...budgetBackups);

      // options = data.map(o => {
      //   if (o.type === "BUDGET_BACKUP")
      //     return { label: o.budgetBackupName, id: o.id };
      //   else if (o.type === "REAL")
      //     return { label: `ids_real ${o.year}`, id: o.id };
      //   else if (o.type === "ROLLING_BUDGET")
      //     return { label: `ids_rollingBudget`, id: o.id };
      // });

      let value = options[0];

      if (this.props.type === "ROLLING_BUDGET") {
        value = options[0];
      }
      if (this.props.type === "BUDGET_BACKUP") {
        // value = budgetBackups[0];   
        value = _.filter(budgetBackups, { id: this.props.id })[0];
      }
      if (this.props.type === "REAL") {
        if (!!!this.props.year) {
          // no year specified
          value = {...real[0]};
        } else {
          value = {..._.filter(real, { year: this.props.year })[0]};
        }

        if (this.props.customDate) {
          value.id = null;
          value.year = null;
          value.label = this.props.intl.formatMessage({ id: "ids_real" });
        }
      }

      this.setState({
        type: this.props.type,
        options,
        value,
        budgetBackups,
        real
      });
    }
  }

  render = () => {
    // let option = {
    //   label: key,
    //   options: value.map(category => {
    //     return {
    //       label: category.name,
    //       value: category.id,
    //       element: category
    //     };
    //   })
    // };

    /*
    getPeriodSelecterDataForSales: Array(9)
      0: {id: "fakeId_real_2018", type: "REAL", budgetBackupName: null, budgetBackupDate: null, year: 2018, …}
      1: {id: "fakeId_real_2019", type: "REAL", budgetBackupName: null, budgetBackupDate: null, year: 2019, …}
      2: {id: "fakeId_real_2017", type: "REAL", budgetBackupName: null, budgetBackupDate: null, year: 2017, …}
      3: {id: "fakeId_real_2020", type: "REAL", budgetBackupName: null, budgetBackupDate: null, year: 2020, …}
      4: {id: "fakeId_rolling_budget", type: "ROLLING_BUDGET", budgetBackupName: null, budgetBackupDate: null, year: null, …}
      5: {id: "ck5fijtjyp5kk0b89sa7wm96x", type: "BUDGET_BACKUP", budgetBackupName: "Budget_2019_JANV", budgetBackupDate: "2020-01-15T16:22:22.953Z", year: null, …}
      6: {id: "ck5fim252p8x10b2066apfzgo", type: "BUDGET_BACKUP", budgetBackupName: "Budget_2020_1", budgetBackupDate: "2020-01-15T16:24:07.385Z", year: null, …}
      7: {id: "ck5fizfljns6h0b933ex25mjx", type: "BUDGET_BACKUP", budgetBackupName: "Budget_2020_1b", budgetBackupDate: "2020-01-15T16:34:31.329Z", year: null, …}
      8: {id: "ck5fj02p3p62r0b89kkdglbos", type: "BUDGET_BACKUP", budgetBackupName: "Budget_2020_1c", budgetBackupDate: "2020-01-15T16:35:01.257Z", year: null, …}
      length: 9
    */
    // console.log("45 - props=", this.props);

    // const option = { label: "label", value: "id", element: "cat" };
    // let options = [];
    // options.push(option);

    // console.log("177 - state=", this.state);

    return (
      <SimpleSelect
        creatable={false}
        name="budgetSelector"
        value={this.state.value}
        onSelected={value => {
          this.setState({ value });
          this.props.onSelect &&
            this.props.onSelect({ value, name: this.props.name });
        }}
        options={this.state.options}
        // onNewOptionClick={category => {
        //   setInputCategory(category.value);
        //   setSideModalVisible(true);
        // }}
        disabled={false}
      />
    );
  };
}

export default compose(
  data,
  injectIntl
)(BudgetSelect);
